<template>
  <input
    ref="input"
    class="form-input"
    :type="type"
    v-model="$attrs.modelValue"
    v-bind="$attrs"
  >
</template>

<script>
import { ref } from 'vue';

export default {
  inheritAttrs: false,
  props: {
    type: {
      type: String,
      default: 'text',
    },
  },
  setup() {
    const input = ref();

    function focus() {
      input.value.focus();
    }

    function select() {
      input.value.select();
    }

    function setSelectionRange(start, end) {
      input.value.setSelectionRange(start, end || start);
    }

    return {
      input,
      focus,
      select,
      setSelectionRange,
    }
  }
}
</script>
